/* @flow */
import * as React from 'react';
import { genRuby } from '@sonyged/ext-proc';

type Props = {
  children?: string,
};

export const RubyText = React.memo<Props, _>(function RubyText(props: Props) {
  const { children: text } = props;
  return genRuby(text);
});
